<template>
  <transition name="modal">
    <div id="ecommerce_product_edit" class="modal-notify">
      <div class="modal-wrapper" role="document" style="overflow-y: auto; position: absolute">
        <div
          :style="{
            width: modalWidth ? modalWidth : '',
            height: modalHeight ? modalHeight : '',
          }"
          class="modal-notify-container"
          :class="{ 'modal-notify-size': !isFixed, 'modal-fixed modal-notify-size': isFixed }"
        >
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <div style="margin-bottom: 0">
                <slot name="header"></slot>
              </div>
            </div>
            <div class="modal-body">
              <slot name="body"></slot>
            </div>

            <div class="modal-footer">
              <slot name="footer"> </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isFixed: {
      default: false,
      type: Boolean,
    },
    modalWidth: {
      default: '',
    },
    modalHeight: {
      default: '',
    },
  },
  mounted: function () {
    var vm = this
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        vm.$emit('close')
      }
    })
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ModalNotify.vue